import { loadJavascript } from './toolbox';

let adformInitialized = false;

export function loadConsentOnlyFeatures ({ gdprApplies, tcString } = {}) {
	initializeAdform({ gdprApplies: gdprApplies, tcString: tcString });
	loadGtm();
}

export function loadGtm () {
	if (!js_params.gtmEnabled) {
		return;
	}
	loadJavascript(
		{
			src: `/static/v${js_params.version}/assets/resources/build/js/plugins/gtmLoader.js`
		},
		{
			async: '',
			defer: '',
			id: 'gtm-script'
		});
}

export function initializeAdform ({ gdprApplies, tcString } = {}) {
	if (adformInitialized) {
		return;
	}

	adformInitialized = true;

	// Adform V1 / banner placements
	if (window.innerWidth >= 992 && js_params.adFormUrl) {
		console.log('initializeAdform:loading:adform');

		initializeAdformPlacements({ gdprApplies, tcString });

		loadJavascript({ src: js_params.adFormUrl }, { async: '', defer: '', id: 'adform-script' }, () => window?.adformtag?.addRequestGroup?.(js_params.adformMids));
	}

	// Adform V2 / DMP tracking
	if (js_params.module?.AdformV2?.adformDMPEnabled && js_params.module?.AdformV2?.adformPageName) {
		initializeAdformTracking({ gdprApplies, tcString });
	}
}

/**
 * Initialize Adform banner placements.
 */
function initializeAdformPlacements ({ gdprApplies, tcString } = {}) {
	document.querySelectorAll('[data-adform-placeholder]')
		.forEach((placeholder) => {
			const baseUrl = placeholder.dataset.adformUrl;

			if (!baseUrl) {
				return;
			}

			const adformUrl = addAdformConsentToUrl(baseUrl, gdprApplies, tcString);

			const script = document.createElement('script');

			script.dataset.adfscript = adformUrl;

			placeholder.replaceWith(script);
		});
}

/**
 * Add GDPR parameters when GDPR information has been provided.
 *
 * When called without GDPR data, return the original URL unchanged
 * for backwards compatibility.
 */
function addAdformConsentToUrl (url, gdprApplies, tcString) {
	if (gdprApplies === undefined && !tcString) {
		return url;
	}

	const params = [];

	if (typeof gdprApplies === 'boolean') {
		params.push(`gdpr=${gdprApplies ? 1 : 0}`);
	}

	if (gdprApplies === true && tcString) {
		params.push(`gdpr_consent=${encodeURIComponent(tcString)}`);
	}

	if (!params.length) {
		return url;
	}

	return `${url}&${params.join('&')}`;
}

/**
 * Initialize Adform DMP tracking.
 */
function initializeAdformTracking ({ gdprApplies, tcString } = {}) {
	window._adftrack = Array.isArray(window._adftrack)
		? window._adftrack
		: (window._adftrack ? [window._adftrack] : []);

	const item = {
		HttpHost: 'track.adform.net',
		pm: 806852,
		divider: encodeURIComponent('|'),
		pagename: encodeURIComponent(js_params.module.AdformV2.adformPageName),

		order: {
			sv1: js_params.module.AdformV2.country,
			sv2: js_params.module.AdformV2.continent,
			sv3: js_params.module.AdformV2.fromcountry,
			sv4: js_params.module.AdformV2.fromcity,
			sv5: js_params.module.AdformV2.tocity,
			sv6: js_params.module.AdformV2.adults,
			sv7: js_params.module.AdformV2.children,
			sv8: js_params.module.AdformV2.leavedate,
			sv9: js_params.module.AdformV2.homedate,
			sv10: js_params.module.AdformV2.domain,
			sv11: js_params.module.AdformV2.path,
			sv12: js_params.module.AdformV2.fromIata,
			sv13: js_params.module.AdformV2.toIata
		}
	};

	// Only add GDPR fields when GDPR information was supplied.
	if (typeof gdprApplies === 'boolean') {
		item.gdpr = gdprApplies;

		if (gdprApplies && tcString) {
			item.gdpr_consent = tcString;
		}
	}

	window._adftrack.push(item);

	const script = document.createElement('script');

	script.type = 'text/javascript';
	script.async = true;
	script.src = 'https://s2.adform.net/banners/scripts/st/trackpoint-async.js';

	const firstScript = document.getElementsByTagName('script')[0];

	firstScript.parentNode.insertBefore(
		script,
		firstScript
	);
}
